module.exports = __webpack_public_path__ + "static/media/icons-close-hover.5ffdfcf1.svg";